import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, BrowserRouter as Router, Route, Link } from "react-router-dom";
function ActiveCustomer() {
    const [loading, setLoading] = useState(true);
    const [stbCount, setStbCount] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [allCustomer, setAllCustomer] = useState([]);
    const [networkName, setNetworkName] = useState([]);
    const [streetName, setStreetName] = useState([]);
    const [staffCode, setStaffCode] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ area_code: "", network: "", date: "", toDate: "" })
    const initialFormData = { area_code: "", network: "", date: "", toDate: "" }
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const downloadCSV = () => {
        const headers = ["Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name", "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount", "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network", "Paid_time", "Package", "Added_date", "Collection Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        allCustomer.forEach(row => { csvRows.push([row.id, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno, row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt, row.paid_date, row.balance, row.discount, row.extra_Balance_amt, row.pend_amt, row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy].join(",")); });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = allCustomer.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(allCustomer.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const handleClear = () => { setFormData(initialFormData); };
   
    const fetchUserData = async () => {
        try {
            const response = await axios.post('https://node.cabletvpay.in/activeCustomerGetInfo', { user });
            if (response.status === 200) {
                setNetworkName(response.data.net_name);
                setStbCount(response.data.allCustomer.length);
                setStaffCode(response.data.staffCode);
                setStreetName(response.data.streetDetails);
                setAllCustomer(response.data.allCustomer);
            }
        } catch (err) { setError(err.response?.data?.message || "Error fetching data"); }
        finally { setLoading(false); }
    };
    const stb = useMemo(() => allCustomer.map(row => parseInt(row.serial_num, 10)), [allCustomer]);
    const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
    useEffect(() => { fetchUserData(); }, []);
    if (loading) return (<div className="content-wrapper">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" ariaLabel="rotating-lines-loading" wrapperStyle={{}} wrapperClass="" />
        </div></div>)
    if (error) return <div className='d-flex justify-content-center align-items-center min-vh-100'>Error: {error}</div>;
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4 ">Active Customer Details</div>
                </div>
                <hr />
                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn py-2">
                        <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                            <h4 className="text-navy h5">Customer Details</h4>
                            <div className="input-group w-25">
                                <input type="text" className="form-control text-navy bg-light border-0 h-50 px-2" placeholder="Search..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ borderRadius: "5px 0 0 5px" }} />
                                <span
                                    className="input-group-text bg-light text-navy border-0 px-2"
                                    id="basic-addon1"
                                    style={{ borderRadius: "0 5px 5px 0" }}
                                >
                                    <i className="fas fa-search" />
                                </span>
                            </div>

                            {/* Actions */}
                            <div className="d-flex flex-column flex-md-row align-items-center ">


                                <div className="d-flex justify-content-end btn-group">
                                    <button onClick={downloadCSV} className="btn py-1 btn-dark border-right"><i className="fas fa-file-excel" />&nbsp;Excel Download</button>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="card-body p-0">
                                                            <table id="myTable" className="table table-bordered  table-responsive">                          
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No     </th>
                                    <th>
                                        Customer__Name
                                    </th>
                                    <th>Acc_no</th>
                                    <th>Code</th>
                                    <th>STB_no</th>
                                    <th>D_no</th>
                                    <th>Flat_name</th>
                                    <th>Street__name</th>
                                    <th>Phone</th>
                                    <th>Pay Status</th>
                                    <th>Plan Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Paid__Date</th>
                                    <th>Paid Time</th>
                                    <th>Balance Amount</th>
                                    <th>Discount Amount</th>
                                    <th>Advance Amount</th>
                                    <th>Pending_Amount</th>
                                    <th>Staff__Code</th>
                                    <th>Networks</th>
                                    <th>Packages</th>
                                    <th>Connection Status</th>

                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index} style={{ backgroundColor: row.status === "unpaid" ? "#ffcccb" : "#dbffdb" }}>
                                           <td className='tableText border-dark text-bold'>{indexOfFirstRow + index + 1}</td>
                                            <td className='tableText border-dark text-bold'>{row.name}</td>
                                            <td className='tableText border-dark text-bold'>{row.account_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.acc_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.serial_num}</td>
                                            <td className='tableText border-dark text-bold'>{row.doorno}</td>
                                            <td className='tableText border-dark text-bold'>{row.flat_name}</td>
                                            <td className='tableText border-dark text-bold'>{row.street}</td>
                                            <td className='tableText border-dark text-bold'>{row.mobile}</td>
                                            <td className='tableText border-dark text-bold'>{row.status}</td>
                                            <td className='tableText border-dark text-bold'>{row.pay_amt}</td>
                                            <td className='tableText border-dark text-bold'>{row.paid_amt}</td>
                                            <td className='tableText border-dark text-bold'>{row.paid_date}</td>
                                            <td className='tableText border-dark text-bold'>{row.paid_time}</td>
                                            <td className='tableText border-dark text-bold'>{row.balance_amt}</td>
                                            <td className='tableText border-dark text-bold'>{row.discount}</td>
                                            <td className='tableText border-dark text-bold'>{row.extra_balance_amt}</td>
                                            <td className='tableText border-dark text-bold'>{row.pend_amt}</td>
                                            <td className='tableText border-dark text-bold'>{row.area_code}</td>
                                            <td className='tableText border-dark text-bold'>{row.net_name}</td>
                                            <td className='tableText border-dark text-bold'>{row.package}</td>
                                            <td className='tableText border-dark text-bold'>
                                                      {row.con_status === "active" || row.con_status === "Active" ? (
                                                        <button className="btn btn-success">Active</button>
                                                      ) : row.con_status === "active" || row.con_status === "Active" ? (
                                                        <div className="d-flex-column"><button className="btn btn-success">active </button></div>
                                                      ) : (
                                                        <div className="d-flex-column"><button className="btn btn-secondary">{row.con_status}</button></div>
                                                      )}
                                                    </td>

                                        </tr>
                                    ))) : (<tr><td colSpan="10">No results found</td></tr>)}

                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="d-flex justify-content-end">
                    <div className="pagination btn-group">
                        {/* Previous Button */}
                        <button
                            className="btn bg-secondary border-right"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{ opacity: currentPage === 1 ? 0.6 : 1 }}
                        >
                            <i className="fas fa-backward"></i>

                        </button>

                        {/* First Page Button */}
                        <button
                            onClick={() => paginate(1)}
                            className={`btn ${currentPage === 1 ? "bg-navy" : "btn-secondary"} border-left`}
                        >
                            1
                        </button>

                        {/* Ellipsis Before Current Range */}
                        {currentPage > 3 && <span className="mx-1">...</span>}

                        {/* Middle Page Buttons */}
                        {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                            .filter((page) => page > 1 && page < totalPages)
                            .map((page) => (
                                <button
                                    key={page}
                                    onClick={() => paginate(page)}
                                    className={`btn ${currentPage === page ? "bg-navy" : "btn-outline-secondary"}`}
                                    style={{ fontWeight: currentPage === page ? "bold" : "normal" }}
                                >
                                    {page}
                                </button>
                            ))}

                        {/* Ellipsis After Current Range */}
                        {currentPage < totalPages - 2 && <span className="mx-1">...</span>}

                        {/* Last Page Button */}
                        {totalPages > 1 && (
                            <button
                                onClick={() => paginate(totalPages)}
                                className={`btn ${currentPage === totalPages ? "bg-navy" : "btn-secondary"} border-right`}
                            >
                                {totalPages}
                            </button>
                        )}

                        {/* Next Button */}
                        <button
                            className="btn btn-secondary  border-left"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{ opacity: currentPage === totalPages ? 0.6 : 1 }}
                        >
                            <i className="fas fa-forward"></i>

                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ActiveCustomer;
